module.exports = __webpack_public_path__ + "img/lpfv-sp-3000.7be8d83b.png";